<template>
  <img
    v-if="src"
    :src="getImage"
    :alt="alt"
    :loading="lazyLoad ? 'lazy' : ''"
  >
</template>

<script>
export default {
  name: 'Image',

  props: {
    src: {
      type: String,
      default: null,
    },
    alt: {
      type: String,
      default: '',
    },
    lazyLoad: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    getImage () {
      if (this.src.indexOf('@/assets/') === 0) {
        return require(`@/assets/${this.src.replace('@/assets/', '')}`)
      }

      return this.src
    },
  },
}
</script>

<style >

</style>
